import axios from 'axios'

const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/modularContents`

export const getPage = async () =>
  await axios.get(endpoint)

export const getModules = async (id, page = 1) =>
  await axios.get(`${endpoint}/${id}/modules?page=${page}`)

export const getWishlist = async () =>
  await axios.get('/api/boitata/v1/wishlists/ids')
